import React, { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import { useGetVideosQuery } from '../../features/videos/videosApi';
import VideoContainer from './VideoContainer';
import VideoLists from './VideoLists';

const CoursePlayer = () => {
    const navigate = useNavigate()
    const { data, isLoading, isError, isSuccess } = useGetVideosQuery()
    const { id } = useParams()

    useEffect(() => {
        if (!id) {
            if (data?.length) {
                navigate(`/course/${data[0].id}`)
            }
        }
    }, [id, data])
    return (
        <section className="py-6 bg-primary">
            <div className="mx-auto max-w-7xl px-5 lg:px-0">
                <div className="grid grid-cols-3 gap-2 lg:gap-8">
                    <div className="col-span-full w-full space-y-8 lg:col-span-2">
                        {
                            !id && <div>
                                Loading
                            </div>
                        }


                        <Outlet></Outlet>
                    </div>

                    <VideoLists data={data} isLoading={isLoading} ></VideoLists>
                </div>
            </div>
        </section>
    );
};

export default CoursePlayer;